<template>
  <div>
    <vx-card title="Seznam naloženih datotek">
      <vs-alert color="danger"
                class="mb-2"
      >Spodaj je seznam vseh datotek, ki so bile naložene. Če izbrišete datoteko s seznama, se z njo izbrišejo tudi podatki prikazani v analitiki. Bodite previdni saj se izbrisane datoteke ne da povrniti!
      </vs-alert
      >
      <div>
        <vs-table :data="fileList"
                  search
                  pagination
                  max-items="5">
          <template slot="thead">
            <vs-th sort-key="filename">Ime datoteke</vs-th>
            <vs-th sort-key="datetimeuploaded">Naloženo</vs-th>
            <vs-th sort-key="filesize">Velikost (kB)</vs-th>
            <vs-th sort-key="filetype.filetype">Tip datoteke</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr"
                   :key="index"
                   v-for="(tr, index) in data">
              <td>{{data[index].filename}}</td>
              <td>
                {{data[index].datetimeuploaded | moment('HH:mm DD.MM.Y')}}
              </td>
              <td>{{data[index].filesize | convertTokB}} kB</td>
              <td>{{data[index].filetype.filetype}}</td>
              <td>
                <vs-button
                  style="font-size: 1.5rem"
                  type="border"
                  radius
                  @click="onDeleteButtonClicked(data[index].uploadedfileid)"
                  color="danger"
                  icon="delete_forever"
                ></vs-button>
              </td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup :active.sync="deleteConfirmation"
              title="Izbriši datoteko">
      <p>Ali res želite izbrisati datoteko in z njo vse podatke?</p>
      <div class="flex justify-center">
        <vs-button color="primary"
                   class="m-2"
                   @click="resetDelete"
        >Prekliči
        </vs-button
        >
        <vs-button color="danger"
                   class="m-2"
                   @click="deleteFileByID"
        >Izbriši
        </vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        deleteConfirmation: false,
        fileIDToDelete: 0
      }
    },
    filters: {
      convertTokB: function (value) {
        if (!value) return '0'
        let bytes = parseInt(value)
        let kB = bytes / 1024
        return kB.toFixed(2)
      }
    },
    methods: {
      resetDelete () {
        this.fileIDToDelete = 0
        this.deleteConfirmation = false
      },
      onDeleteButtonClicked (fileID) {
        this.fileIDToDelete = fileID
        this.deleteConfirmation = true
      },
      async fetchData () {
        this.$vs.loading()
        try {
          await this.$store.dispatch('data/fetchFileList')
        } catch (error) {
          this.$vs.notify({
            title: 'Napaka pri nalaganju podatkov!',
            text: `Pri dobivanju podatkov je prišlo do napake!\n${error}`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } finally {
          this.$vs.loading.close()
        }
      },
      async deleteFileByID () {
        this.$vs.loading()
        try {
          await this.$store.dispatch('data/deleteFileByID', this.fileIDToDelete)

          this.$vs.notify({
            title: 'Uspešno izbrisano!',
            text: `Datoteka je bila uspešno izbrisana`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.resetDelete()
        } catch (error) {
          this.$vs.notify({
            title: 'Napaka pri brisanju datoteke!',
            text: `Pri brisanju datoteke je prišlo do napake!\n${error}`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    },
    computed: {
      fileList () {
        return this.$store.state.data.fileList.slice()
      }
    },
    async created () {
      await this.fetchData()
    }
  }
</script>
